import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { useWhitelabel } from 'main/framework'
import { SchoolPage_school_profile_programOfferings } from 'main/pages/School/gql'
import { HeartEnvelopeIcon, Strong, Text } from 'main/ui'
import { AssetName } from 'main/util/asset'

import { LOCIZE_NAMESPACE } from '../../../common'
import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-PROGRAM-OFFERINGS`

interface IProps {
  programOfferings: SchoolPage_school_profile_programOfferings[]
}

interface IProgramOfferingTextProps {
  id: number
  slug: string
}

function ProgramOfferingText({ id, slug }: IProgramOfferingTextProps) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Text key={id} muted>
      {t(`PROGRAM-OFFERING-${slug.toUpperCase()}`)}
    </Text>
  )
}

export default function EnabledProgramOfferings(props: IProps) {
  const { networkAbbr, hideByDefaultExceptIfTrue } = useWhitelabel()
  const { programOfferings } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const show =
    hideByDefaultExceptIfTrue(AssetName.PROGRAM_OFFERINGS) &&
    !!programOfferings &&
    programOfferings.length > 0

  if (!show) {
    return null
  }

  return (
    <Bullet icon={<HeartEnvelopeIcon />}>
      <Strong>{t(`${PRE}-TITLE-${networkAbbr}`)}</Strong>
      {programOfferings.map(ProgramOfferingText)}
    </Bullet>
  )
}
